export const product = {
  productDetails: {
    id: 'ID',
    quantity: 'quantité',
    productDetails: 'Détails du produit',
    specification: 'Spécs',
    reviews: 'Critiques',
    shipping: 'Expédition',
    share: 'Partager',
    showReviews: 'Afficher les commentaires',
    noReviews: 'Pas encore de commentaires',
    productPrice: 'Prix du produit',
  },
  productList: {
    filterBy: {
      label: 'Filtrer par',
      action: 'Filtrer par',
    },
    appliedFilter: 'Filtre appliqué:',
    showLess: 'Afficher moins...',
    showMore: 'Afficher plus...',
    sortBy: 'Trier par',
    backToTopBtn: 'RETOUR AU DÉBUT',
    showMoreBtn: 'AFFICHER PLUS',
    productSearchPagination: 'Pagination de la recherche de produits',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filtrer par',
      action: 'Filtrer par',
    },
    appliedFilter: 'Filtre appliqué:',
    showLess: 'Montrer moins...',
    showMore: 'Afficher plus...',
    sortBy: 'Trier par',
  },
  productSummary: {
    id: 'ID',
    showReviews: 'Afficher les commentaires',
    share: 'Partager',
    newItemPrice: 'Prix du nouvel article',
  },
  productReview: {
    overallRating: 'Note globale',
    reviewTitle: 'Titre de la revue',
    writeYourComments: 'Écrivez vos commentaires',
    rating: 'Classement',
    reviewerName: "Nom de l'examinateur(facultatif)",
    writeReview: 'Rédiger un avis',
    more: 'Afficher plus de commentaires',
    less: 'Montrer moins Revue',
    thankYouForReview:
      "Merci pour la critique ! Notez que les commentaires peuvent nécessiter une révision avant d'apparaître ici.",
    createFirstReview:
      "Il n'y a pas encore d'évaluation pour ce produit. Voulez-vous rédiger le premier avis ?",
  },
  addToCart: {
    itemsAddedToYourCart: 'Article(s) ajouté(s) à votre panier',
    itemsIncrementedInYourCart:
      'Cet article était déjà dans votre panier. La quantité a été mise à jour.',
    items: 'articles',
    updatingCart: 'Mise à jour du panier...',
    addToCart: 'Ajouter au panier',
    viewCart: 'voir le panier',
    proceedToCheckout: 'passer à la caisse',
    quantity: 'quantité',
    outOfStock: 'En rupture de stock',
    inStock: 'En stock',
    selectStyleAndSize: 'Sélectionnez le style et la taille pour vérifier le stock',
    removeFromCart: 'Retirer le produit du panier',
    closeModal: 'Fermer la modalité',
  },
  TabPanelContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Détails du produit',
      ProductHintsTabComponent: 'Remarques',
      ProductCertificatesTabComponent: 'Certificats',
      ProductReviewsTabComponent: 'Évaluations',
      ProductQuestionsTabComponent: 'Questions sur le produit',
      ProductSizeTabComponent: 'Tailles',
      ProductSpecsTabComponent: 'Caractéristiques du produit',
      ProductPdfsTabComponent: 'Téléchargements',
    },
  },
  addToWishList: {
    add: 'Ajouter à la liste de souhaits',
    remove: 'Retirer de la liste de souhaits',
    anonymous: 'Connectez-vous pour ajouter à la liste de souhaits',
  },
  stockNotification: {
    notifyMe: 'NOTIFIEZ-MOI',
    stopNotify: "NOTIFICATION D'ARRÊT",
    getNotify: 'Soyez informé lorsque ce produit est disponible.',
    getNotifySuffix: 'pour être informé de la disponibilité de ce produit.',
    activateChannelsPrefix: 'Pour être notifié, vous devez activer le',
    channelsLink: 'Canaux de notification',
    activateChannelsSuffix: '.',
    notified: 'Vous serez averti lorsque ce produit sera de nouveau en stock.',
    getNotified: 'Soyez informé lorsque ce produit sera de nouveau en stock.',
    unsubscribeSuccess: 'Vous ne recevrez pas de notification de rupture de stock pour ce produit.',
    subscriptionDialog: {
      header: 'Abonnement en rupture de stock',
      notifiedPrefix: 'Vous serez informé(e) le:',
      notifiedSuffix: 'dès que ce produit sera de nouveau en stock.',
      manageChannelsPrefix: "Gérez vos canaux de notification préférés à l'écran ",
      manageChannelsLink: 'Préférence de notification',
      manageChannelsSuffix: ' page.',
      manageSubscriptionsPrefix: "Vous pouvez gérer vos abonnements à l'adresse suivante ",
      manageSubscriptionsLink: 'Mes intérêts',
      manageSubscriptionsSuffix: ' page.',
      okBtn: 'OK',
      subscribing: 'Vous inscrire aux notifications de rupture de stock pour ce produit',
    },
  },
  itemCounter: {
    removeOne: 'Enlever un',
    addOneMore: 'Ajoutez-en un autre',
    quantity: 'Quantité',
  },
  productView: {
    gridView: 'Sélectionnez pour passer à la vue en grille',
    listView: 'Sélectionnez pour passer à la vue en liste',
  },
};
